import { identity } from 'ramda'

export const channels = identity
